/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { getRequest } from '../../../../../helpers/axiosClient';
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../Icons/Date";
import dayjs from 'dayjs';
import moment from 'moment';
import productActions from "../../../../Product/Product/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box } from "@mui/material";
import purchaseActions from "../../../../Purchase/Management/redux/actions";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';


export const ResaleValueReport = (props) => {
    const { visible, onResaleValueVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);


    const [filterValues, setFilterValues] = useState({
        fromDate: new Date(),
        toDate: new Date(),
    });
    const dispatch = useDispatch();
    const [reportOpen, setReportOpen] = useState(false);
    const [resaleData, setResaleData] = useState([]);
    const [loading, setLoading] = useState(false);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const resaleFilter = (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let filter = { ["and"]: [] };

            if (filterValues?.supplier?.id) {
                filter['and'].push({ partyId: filterValues?.supplier?.id }, { serviceReference: 'PURCHASE' });
            }

            if (filterValues?.product?.id) {
                filter['and'].push({ productId: filterValues?.product?.id });
            }

            if (filterValues?.fromDate && filterValues?.toDate) {
                filter['and'].push({ transactionDate: { between: [dayjs(filterValues?.fromDate).format('YYYY-MM-DD'), dayjs(filterValues?.toDate).format('YYYY-MM-DD')] } });
            }

            let f = {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: 'id desc',
            }

            let response = getRequest(`${process.env.REACT_APP_API_URL}/inventory-transactions?filter=${encodeURIComponent(JSON.stringify(f))}`);
            response.then(payload => {
                setResaleData(payload.data);
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (visible) {
            supplierApi();
            productApi();
        }
    }, [visible])

    const handleClose = () => {
        setFilterValues({
            fromDate: new Date(),
            toDate: new Date(),
        });
        onResaleValueVisible(false);
        onMenuTitle('');
    }

    const resaleTitle = (filterValues) => {
        if (filterValues?.fromDate && filterValues?.toDate) {
            return `From ${moment(filterValues?.fromDate).format("DD/MM/YYYY")} To ${moment(filterValues?.toDate).format("DD/MM/YYYY")}`;
        }
        return '';
    }

    const resaleSubTitle = (values = {}) => {
        const parts = [];

        if (values.product?.productName) {
            parts.push(`Product: ${values.product.productName}`);
        }

        if (values.supplier?.name) {
            parts.push(`Supplier: ${values.supplier.name}`);
        }

        return parts.join(' | ');
    };

    const supplierApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: purchaseActions.SUPPLIER_DETAILS_START, url: 'supplierProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const changeHandler = (e, name = '', relation = false) => {
        if (relation) {
            setFilterValues({
                ...filterValues,
                [name]: e
            });
        } else {
            setFilterValues({
                ...filterValues,
                [name]: e
            });
        }

    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => resaleFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <div className={clsx(classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={filterValues?.fromDate ?? ''}
                                        format='dd/MM/yyyy'
                                        label="From Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('From Date', 'resaleValue', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                changeHandler(new Date(), 'fromDate') : changeHandler(newValue, 'fromDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={filterValues?.toDate ?? ''}
                                        format='dd/MM/yyyy'
                                        label="To Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('To Date', 'resaleValue', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                changeHandler(new Date(), 'toDate') : changeHandler(newValue, 'toDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <AutoCompleteComponent
                                name={`Product `}
                                heads={[{ key: "productName", name: "Product Name" },
                                { key: "code", name: "Product Code" },
                                { key: "productId", name: "Product ID" }]}
                                details={myProductdetails}
                                id={idNamingConversion("Product", "resaleValue", "DropDown")}
                                parentValue={customObject(myProductdetails, filterValues?.product?.id)}
                                onChange={(data) => changeHandler(data, 'product', true)}
                                position="bottom"
                                searchType={(s) => productApi(s)}
                                customClasses={classes.margin30t}
                            />
                            <AutoCompleteComponent
                                name={["Supplier Name "]}
                                heads={[{ 'key': 'name', 'name': 'Supplier Name' },
                                { 'key': 'mobile', 'name': 'Phone Number' },
                                { 'key': 'serialNo', 'name': 'Supplier ID' }]}
                                details={supplierDetails}
                                id={idNamingConversion('Supplier Name', 'resaleValue', 'DropDown')}
                                parentValue={customObject(supplierDetails, filterValues?.supplier?.id)}
                                onChange={(data) => changeHandler(data, 'supplier', true)}
                                searchType={(s) => supplierApi(s)}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title} - {resaleTitle(filterValues)}</h4>
                            <p className={classes.downloadsHeading}>{resaleSubTitle(filterValues)}</p>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Date</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Pro. ID</h6></Col>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Pro. Des.</h6></Col>
                            <Col span={1}><h6 style={{ fontSize: 14 }}>Sto. Qty.</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Sto. Ut.</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Cost Per Price</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Cost Amount</h6></Col>
                            <Col span={1}><h6 style={{ fontSize: 14 }}>Bill Qty.</h6></Col>
                            <Col span={1}><h6 style={{ fontSize: 14 }}>Bill Unit</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Price Per Unit</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>MRP</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Resale Value</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Party Name</h6></Col>
                        </Row>
                        {
                            resaleData?.length > 0 ? resaleData.map((data, i) => (
                                <Row className={clsx(classes.bill, 'no-break')}>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{moment(data?.transactionDate).format('DD MMM YYYY')}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.product?.productId || ''}</p></Col>
                                    <Col span={3}><p style={{ fontSize: 14, padding: "0 5px" }}>{data?.product?.productName}</p></Col>
                                    <Col span={1}><p style={{ fontSize: 14 }}>{data?.quantity || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.unit?.name || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.cost_per_unit ? `₹ ${currencyFormat(data?.cost_per_unit || 0)}` : '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.line_amount ? `₹ ${currencyFormat(data?.line_amount || 0)}` : '---'}</p></Col>
                                    <Col span={1}><p style={{ fontSize: 14 }}>{data?.billQuantity || '---'}</p></Col>
                                    <Col span={1}><p style={{ fontSize: 14 }}>{data?.billUnit?.name || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.price_per_unit ? `₹ ${currencyFormat(data?.price_per_unit || 0)}` : '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.product?.mrp ? `₹ ${currencyFormat(data?.product?.mrp || 0)}` : '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.product?.mrp ? `₹ ${currencyFormat((data?.quantity * data?.product?.mrp))}` : '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.party_name || '---'}</p></Col>

                                </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                        }
                    </>
                }
                businessDetails={businessDetails}
                reportType={'landscape'}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}
